/**
 * Самоісцільна перевірка версії — лікує агресивний кеш Telegram (юзер
 * 2026-06-15: «оновлення не долітають»).
 *
 * Аппка має вшитий __BUILD_ID__ (vite define). На старті тягне свіжий
 * /version.json (cache-bust + no-store). Якщо id на сервері інший — поточна
 * збірка застаріла → форсуємо перезавантаження нового бандла.
 *
 * ⚠️ owner 2026-07-23: простий `location.reload()` НЕ допомагав — Telegram-
 * WebView (особливо Desktop/macOS) віддавав index.html із липкого кешу навіть
 * при no-store, і юзер залишався на старому бандлі (бачив нові екрани, але старі
 * ассети). Фікс: переходимо на НОВИЙ URL `?_v=<id>` — цього URL у кеші ще не
 * було, тому index.html тягнеться з мережі (SPA fallback, no-store) → новий
 * бандл. Зберігаємо pathname + hash (у hash — Telegram initData, без нього
 * зламається авторизація). Guard у sessionStorage не дає зациклитись.
 */
export function checkAppVersion(): void {
  if (typeof window === "undefined") return;
  const current = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "";
  if (!current) return;
  fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" })
    .then((r) => (r.ok ? r.json() : null))
    .then((data: { id?: string } | null) => {
      if (!data?.id || data.id === current) return;
      const key = `reloaded_for_${data.id}`;
      if (sessionStorage.getItem(key)) return; // вже перезавантажили під цю версію
      sessionStorage.setItem(key, "1");
      try {
        // Новий URL форсує мережеве завантаження index.html навіть у липкому
        // WebView-кеші. `set` (не append) → без накопичення при повторних
        // апдейтах. Зберігаємо інші query + hash (Telegram initData).
        const params = new URLSearchParams(window.location.search);
        params.set("_v", data.id);
        window.location.replace(
          window.location.pathname + "?" + params.toString() + window.location.hash,
        );
      } catch {
        window.location.reload();
      }
    })
    .catch(() => {
      /* офлайн / version.json недоступний — ігноруємо */
    });
}
